import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CustomizableSnackbar from '../../components/Snackbar/Snackbar';
import Copyright from '../../components/Copyright/Copyright';
import { sendPasswordResetEmail } from '../../api/usersAPI';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function ForgotPassword({ ...props }) {
  const classes = useStyles();
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackbarVariant, setSnackbarVariant] = useState('info');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [email, setEmail] = useState();
  const emailRegex = new RegExp('[\\s]');

  const handleForgotPassword = () => {
    if (emailRegex.test(email)) {
      setSnackbarVariant('error');
      setSnackbarMessage(`An email must not contain any spaces.`);
      setIsSnackbarOpen(true);
      return;
    }
    if (!email) {
      setSnackbarVariant('error');
      setSnackbarMessage(`Input validation failed.`);
      setIsSnackbarOpen(true);
      return;
    }
    try {
      sendPasswordResetEmail(email);
      setSnackbarVariant('success');
      setSnackbarMessage(`Password reset email sent to ${email}.`);
      setIsSnackbarOpen(true);
      setEmail('');
    } catch (e) {
      setSnackbarVariant('error');
      setSnackbarMessage(`Password reset email failed to send to ${email}. Please try again later.`);
      setIsSnackbarOpen(true);
    }
  }
  const handleSignIn = () => {
    props.history.push('/signin');
  }
  const handleSnackbarClose = (_, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsSnackbarOpen(false);
  };
  return (
    <Container component="main" maxWidth="xs">
      <CustomizableSnackbar
        open={isSnackbarOpen}
        handleClose={handleSnackbarClose}
        variant={snackbarVariant}
        message={snackbarMessage}
      />
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Password Reset
        </Typography>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
              />
            </Grid>
          </Grid>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleForgotPassword}
            disabled={!email}
          >
            Forgot Password
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link onClick={handleSignIn} variant="body2">
                Remember your password? Sign in
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}
